import { createRouteContextObject } from '@shared/utils';
import { HttpContextBase } from './http-context-base.enum';

enum HttpContextRoutes {
  GetUserRightsSubproject,
  UserAdminSyncUserRightsSubproject,

  //User Admin
  GetUsers,
  SyncUsers,

  //System Admin
  GetSystemAdmins,
  UserAdminSyncSystemAdmins,
}

export const HttpUserAdminContext = createRouteContextObject(
  HttpContextBase.UserAdmin,
  HttpContextRoutes
);
